module.exports = __webpack_public_path__ + "static/swift-delivery-time-b97ab82cbac4ee9ccd1d5f73ef419d31.png";